var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CardFaction } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MarketDetailsTab, RoutePath, generateRoutePath } from '../../app/router/config';
import arkhanteBackground from '../../assets/images/backgrounds/background-product-arkhante.png';
import mantrisBackground from '../../assets/images/backgrounds/background-product-mantris.png';
import riftBackground from '../../assets/images/backgrounds/background-product-rift.png';
import buyIcon from '../../assets/images/icons/common/icon-buy-dark.png';
import Details from '../../components/market-details/details';
import FullscreenImage from '../../components/market-details/fullscreen-image';
import Header from '../../components/market-details/header';
import Orders from '../../components/market-details/orders';
import Overview from '../../components/market-details/overview';
import MultiSelectToolbar from '../../components/multi-select-toolbar';
import { useFilters } from '../../hooks/common/use-filters';
import { useAsset } from '../../hooks/market/use-asset';
import { useMultipleOrders } from '../../hooks/market/use-multiple-orders';
import Layout from '../../layout';
import { TokenType } from '../../types/common';
import NotFound from '../error/not-found';
export default function Asset() {
    var _this = this;
    var _a;
    var t = useI18n().t;
    var _b = useParams(), tokenId = _b.tokenId, tab = _b.tab;
    var navigate = useNavigate();
    var filters = useFilters();
    var asset = useAsset(tokenId, filters, tab);
    var _c = useMultipleOrders(asset.onSaleOrders || [], function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, asset.getOnSaleOrders({ options: { refresh: true }, assetData: asset.asset })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }, { disabledOwned: true }), selectedOrderIds = _c.selectedOrderIds, prices = _c.prices, notEnoughCurrency = _c.notEnoughCurrency, selectOrder = _c.selectOrder, shiftSelectOrder = _c.shiftSelectOrder, selectAllOrders = _c.selectAllOrders, unselectedAllOrders = _c.unselectedAllOrders, showBuySingleAssetDialog = _c.showBuySingleAssetDialog, showBuyMultipleAssetsDialog = _c.showBuyMultipleAssetsDialog;
    var _d = useState(false), showFullScreenImage = _d[0], setShowFullScreenImage = _d[1];
    useEffect(function () {
        unselectedAllOrders();
    }, [tab]);
    if (asset.asset === null) {
        return _jsx(NotFound, {});
    }
    if (!tab || !Object.values(MarketDetailsTab).includes(tab)) {
        navigate(generateRoutePath(RoutePath.ASSET, {
            tokenId: tokenId,
            tab: MarketDetailsTab.OVERVIEW,
        }), { replace: true });
        return _jsx(_Fragment, {});
    }
    function getBackground() {
        var _a;
        var metadata = (_a = asset.asset) === null || _a === void 0 ? void 0 : _a.metadata;
        if ((metadata === null || metadata === void 0 ? void 0 : metadata.tokenType) && metadata.tokenType !== TokenType.CARD) {
            return arkhanteBackground;
        }
        if ((metadata === null || metadata === void 0 ? void 0 : metadata.tokenType) === TokenType.CARD) {
            switch (metadata.faction) {
                case CardFaction.ARKHANTE: {
                    return arkhanteBackground;
                }
                case CardFaction.MANTRIS: {
                    return mantrisBackground;
                }
                case CardFaction.RIFT: {
                    return riftBackground;
                }
                default: {
                    return undefined;
                }
            }
        }
        return undefined;
    }
    var assetMetadata = (_a = asset.asset) === null || _a === void 0 ? void 0 : _a.metadata;
    var background = getBackground();
    var tabs = [
        {
            label: t('market-details.tabs.overview'),
            path: generateRoutePath(RoutePath.ASSET, {
                tokenId: tokenId,
                tab: MarketDetailsTab.OVERVIEW,
            }),
            selected: tab === MarketDetailsTab.OVERVIEW,
        },
        {
            label: t('market-details.tabs.on-sale'),
            path: generateRoutePath(RoutePath.ASSET, {
                tokenId: tokenId,
                tab: MarketDetailsTab.ON_SALE,
            }),
            selected: tab === MarketDetailsTab.ON_SALE,
        },
        {
            label: t('market-details.tabs.details'),
            path: generateRoutePath(RoutePath.ASSET, {
                tokenId: tokenId,
                tab: MarketDetailsTab.DETAILS,
            }),
            selected: tab === MarketDetailsTab.DETAILS,
            undisplayed: (assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.tokenType) !== TokenType.CARD,
        },
        {
            label: t('market-details.tabs.activity'),
            path: generateRoutePath(RoutePath.ASSET, {
                tokenId: tokenId,
                tab: MarketDetailsTab.ACTIVITY,
            }),
            selected: tab === MarketDetailsTab.ACTIVITY,
        },
    ];
    return (_jsx(Layout, { background: background, children: _jsx(_Fragment, { children: asset.asset && background && (_jsxs(_Fragment, { children: [_jsx(Header, { banner: background, description: assetMetadata.description, isAssetListed: !!asset.assetOrder, name: assetMetadata.name, numbering: assetMetadata.numbering, ownedByUser: asset.ownedByUser, ownerAddress: asset.asset.user, productLink: assetMetadata.tokenType === TokenType.CARD
                            ? generateRoutePath(RoutePath.PRODUCT, {
                                id: assetMetadata.ian,
                                type: assetMetadata.tokenType,
                                tab: MarketDetailsTab.OVERVIEW,
                            })
                            : undefined, showHistoryDialog: assetMetadata.history ? asset.showHistoryDialog : undefined, tabs: tabs, tokenAddress: asset.asset.token_address, tokenId: tokenId, tokenType: assetMetadata.tokenType }), tab === MarketDetailsTab.OVERVIEW && (_jsx(Overview, { advancement: assetMetadata.advancement, assetData: {
                            price: asset.price,
                            buyNow: asset.assetOrder && !asset.ownedByUser ? asset.showBuyNowDialog : undefined,
                            makeOffer: asset.assetOrder && !asset.ownedByUser && !asset.myOffer ? asset.showMakeOfferDialog : undefined,
                            listForSale: !asset.assetOrder && asset.ownedByUser ? asset.showListForSaleDialog : undefined,
                            cancelListing: asset.assetOrder && asset.ownedByUser ? asset.showCancelListingDialog : undefined,
                            editListing: asset.assetOrder && asset.ownedByUser ? asset.showEditListingDialog : undefined,
                            transfer: !asset.assetOrder && asset.ownedByUser ? asset.showTransferDialog : undefined,
                            cancelOffer: asset.myOffer && !asset.ownedByUser
                                ? function () { var _a; return asset.showCancelOfferDialog(((_a = asset.myOffer) === null || _a === void 0 ? void 0 : _a.offer.order_id) || -1); }
                                : undefined,
                            updateOffer: asset.myOffer && !asset.ownedByUser ? asset.showUpdateOfferDialog : undefined,
                        }, ian: assetMetadata.ian || undefined, imageUrl: asset.asset.image_url || '', metadataItems: asset.metadata, myOffer: asset.myOffer, onImageClick: function () { return setShowFullScreenImage(true); }, ownedByUser: asset.ownedByUser, ownerAddress: asset.asset.user, shredPreview: asset.shredPreview, supply: asset.supply, tokenType: assetMetadata.tokenType })), tab === MarketDetailsTab.ON_SALE && (_jsx(Orders, { advancement: assetMetadata.advancement, buyAction: showBuySingleAssetDialog, filters: filters, imageUrl: asset.asset.image_url || '', name: assetMetadata.name, orders: asset.onSaleOrders, selectAllOrders: selectAllOrders, selectOrder: selectOrder, selectedOrderIds: selectedOrderIds, shiftSelectOrder: shiftSelectOrder, tokenType: assetMetadata.tokenType, withoutFiltersMetadata: true })), tab === MarketDetailsTab.DETAILS && (_jsx(Details, { ian: assetMetadata.ian, imageUrl: asset.asset.image_url || '', onImageClick: function () { return setShowFullScreenImage(true); }, relatedContent: asset.relatedContent, tokenType: assetMetadata.tokenType })), tab === MarketDetailsTab.ACTIVITY && (_jsx(Orders, { acceptOfferAction: asset.showAcceptOfferDialog, activity: true, advancement: assetMetadata.advancement, buyAction: showBuySingleAssetDialog, cancelOfferAction: asset.showCancelOfferDialog, filters: filters, imageUrl: asset.asset.image_url || '', name: assetMetadata.name, offers: asset.offers, orders: asset.recentlySoldOrders, ownedByUser: asset.ownedByUser, tokenType: assetMetadata.tokenType, withoutFiltersMetadata: true })), _jsx(FullscreenImage, { background: background, close: function () { return setShowFullScreenImage(false); }, imageUrl: asset.asset.image_url || '', visible: showFullScreenImage }), tab === MarketDetailsTab.ON_SALE && (_jsx(MultiSelectToolbar, { actions: [{ action: showBuyMultipleAssetsDialog, text: t('common.buy-now'), icon: buyIcon }], cancel: unselectedAllOrders, fromTable: true, itemsCount: selectedOrderIds.length, notEnoughCurrency: [notEnoughCurrency.cta, notEnoughCurrency.usdc], prices: [prices.cta, prices.usdc] }))] })) }) }));
}
